// extracted by css-extract-rspack-plugin
export default {"icon":"icon-xj0k4W","title":"title-tYth_Z","message":"message-Lcs62x"};